// import Vue from 'vue';
// import VueCompositionAPI from 'vue';

export default function useVueCompositionAPI() {
    // Vue.use(VueCompositionAPI);
}
